import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16 1H8V5H16V1Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3 3H6V7H18V3H21V10.9172C20.3019 10.6478 19.5432 10.5 18.75 10.5C15.2982 10.5 12.5 13.2982 12.5 16.75C12.5 19.313 13.9446 21.3386 15.0255 22.5271C15.1774 22.6941 15.3288 22.8519 15.4771 23H3V3Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.75 23.7013C18.6826 23.6564 18.6149 23.6118 18.5471 23.5672C18.363 23.446 18.1786 23.3246 18.0005 23.1949C17.8856 23.1113 17.7252 22.9906 17.5345 22.836C17.1545 22.5281 16.6463 22.0799 16.1352 21.5179C15.1403 20.4239 14 18.7512 14 16.75C14 14.1266 16.1266 12 18.75 12C21.3734 12 23.5 14.1266 23.5 16.75C23.5 18.7512 22.3597 20.4239 21.3648 21.5179C20.8537 22.0799 20.3455 22.5281 19.9655 22.836C19.7748 22.9906 19.6144 23.1113 19.4995 23.1949C19.3213 23.3246 19.137 23.4459 18.9528 23.5672C18.8851 23.6118 18.8174 23.6564 18.75 23.7013ZM17.5 16V18H20V16H17.5Z"}}]};

const TaskLocationFilled = Vue.extend<IconProps>({
  name: 'TaskLocationFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'task-location-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default TaskLocationFilled;
